/**
 * Footer.tsx
 * ----------
 * Application footer with company info.
 * - Multilingual company name.
 */


import React from 'react';
import FinnishFlag from './FinnishFlag';
import { useProgress } from '../../context/ProgressContext';

const Footer: React.FC = () => {
  const { language } = useProgress();
  const lang = (['en', 'fi', 'sv'].includes(language) ? language : 'fi') as 'en' | 'fi' | 'sv';

  const t = {
    company: {
      en: 'Redinor Oy',
      fi: 'Redinor Oy',
      sv: 'Redinor Oy',
    },
  };

  return (
    <footer className="flex items-center justify-between gap-4 w-full p-4 
    bg-gradient-to-r from-gray-100 to-gray-300">
      <div className="flex items-center gap-2">
        <FinnishFlag className="w-6 h-6" />
        <span className="font-semibold">{t.company[lang]} &copy; 2025</span>
      </div>
    </footer>
  );
};

export default Footer;
